class JojFakeReviews {
  constructor(el) {
    this.el = el;

    try {
      this.reviews = JSON.parse(el.querySelector('.joj-reviews-data').textContent);
    } catch (e) {
      console.error('[JojFakeReviews] JSON parse error:', e);
      this.reviews = [];
    }

    this.expanded = false;

    const pr = parseInt(el.dataset.previewReviews,  10);
    const er = parseInt(el.dataset.expandedReviews, 10);

    this.cfg = {
      previewReviews:  isNaN(pr) ? 5  : pr,
      expandedReviews: isNaN(er) ? 20 : er,
      toggleLabel:   el.dataset.toggleLabel   || 'See all reviews',
      collapseLabel: el.dataset.collapseLabel || 'See less',
      moreLabel:     el.dataset.moreLabel     || 'More',
      lessLabel:     el.dataset.lessLabel     || 'Less',
    };

    this.shuffled = this._shuffle([...this.reviews]);

    this._render();
    this._bindEvents();
    this._bindDialog();
  }

  _shuffle(arr) {
    for (let i = arr.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [arr[i], arr[j]] = [arr[j], arr[i]];
    }
    return arr;
  }

  _maskName(name) {
    return String(name).split(' ').map(part =>
      part.length <= 3 ? part : part.slice(0, 3) + '*'.repeat(part.length - 3)
    ).join(' ');
  }

  _stars(rating) {
    const n = Math.min(5, Math.max(1, parseInt(rating) || 5));
    return (
      `<span class="joj-fake-reviews__stars-filled" aria-hidden="true">${'★'.repeat(n)}</span>` +
      `<span class="joj-fake-reviews__stars-empty"  aria-hidden="true">${'★'.repeat(5 - n)}</span>`
    );
  }

  _renderReviews(reviews) {
    const list = this.el.querySelector('.joj-fake-reviews__list');
    list.classList.remove('is-visible');

    list.innerHTML = reviews.map(r => `
      <article class="joj-fake-reviews__item">
        <div class="joj-fake-reviews__item-top">
          ${r.photo ? `
          <button class="joj-fake-reviews__item-photo" data-src="${r.photo}" aria-label="View photo">
            <img src="${r.photo}" alt="Customer photo" loading="lazy" width="64" height="64">
          </button>` : ''}
          <div class="joj-fake-reviews__item-meta">
            <div class="joj-fake-reviews__stars" aria-label="${r.rating} stars">
              ${this._stars(r.rating)}
            </div>
            <span class="joj-fake-reviews__author">${this._maskName(r.author)}</span>
            ${r.date ? `<span class="joj-fake-reviews__date">${r.date}</span>` : ''}
          </div>
        </div>
        <div class="joj-fake-reviews__text-wrap">
          <p class="joj-fake-reviews__text">${r.text}</p>
        </div>
        <button class="joj-fake-reviews__more-btn" hidden>${this.cfg.moreLabel}</button>
      </article>
    `).join('');

    list.querySelectorAll('.joj-fake-reviews__item-photo').forEach(btn => {
      btn.addEventListener('click', () => this._openDialog(btn.dataset.src));
    });

    requestAnimationFrame(() => {
      list.classList.add('is-visible');
      list.querySelectorAll('.joj-fake-reviews__item').forEach(item => {
        const wrap = item.querySelector('.joj-fake-reviews__text-wrap');
        const text = item.querySelector('.joj-fake-reviews__text');
        const btn = item.querySelector('.joj-fake-reviews__more-btn');
        if (wrap.scrollHeight > wrap.clientHeight + 4) {
          wrap.classList.add('has-overflow');
          btn.hidden = false;
          btn.addEventListener('click', () => {
            const expanded = item.classList.toggle('is-expanded');
            wrap.classList.toggle('has-overflow', !expanded);
            btn.textContent = expanded ? this.cfg.lessLabel : this.cfg.moreLabel;
          });
        }
      });
    });
  }

  _updateToggle() {
    const btn = this.el.querySelector('.joj-fake-reviews__toggle');
    const hasMore = this.reviews.length > this.cfg.previewReviews;
    btn.hidden = !hasMore;
    btn.textContent = this.expanded ? this.cfg.collapseLabel : this.cfg.toggleLabel;
    btn.setAttribute('aria-expanded', String(this.expanded));
  }

  _render() {
    const count = this.expanded ? this.cfg.expandedReviews : this.cfg.previewReviews;
    this._renderReviews(this.shuffled.slice(0, count));
    this._updateToggle();
  }

  _openDialog(src) {
    const dialog = this.el.querySelector('.joj-fake-reviews__dialog');
    dialog.querySelector('.joj-fake-reviews__dialog-img').src = src;
    dialog.showModal();
  }

  _bindDialog() {
    const dialog = this.el.querySelector('.joj-fake-reviews__dialog');
    dialog.querySelector('.joj-fake-reviews__dialog-close').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', e => { if (e.target === dialog) dialog.close(); });
  }

  _bindEvents() {
    this.el.querySelector('.joj-fake-reviews__toggle').addEventListener('click', () => {
      this.expanded = !this.expanded;
      this._render();
      if (!this.expanded) this.el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }
}

document.querySelectorAll('.joj-fake-reviews').forEach(el => new JojFakeReviews(el));
